import {
  FETCH_WELD_PARAMETERS_REQUEST,
  FETCH_WELD_PARAMETERS_SUCCESS,
  FETCH_WELD_PARAMETERS_FAILURE,
  WELD_PARAMETERS_LOADER_START,
  WELD_PARAMETERS_LOADER_STOP,
  UPDATE_RENAME_PASSES,
  PUT_RENAME_LOADER_START,
  PUT_RENAME_LOADER_STOP,
} from "./types";

export const fetchWeldParametersRequest = (payload) => ({
  type: FETCH_WELD_PARAMETERS_REQUEST,
  payload,
});

export const fetchWeldParametersSuccess = (payload) => ({
  type: FETCH_WELD_PARAMETERS_SUCCESS,
  payload,
});

export const fetchWeldParametersFailure = (error) => ({
  type: FETCH_WELD_PARAMETERS_FAILURE,
  payload: error,
});

export const weldParametersLoaderStart = () => ({
  type: WELD_PARAMETERS_LOADER_START,
});

export const weldParametersLoaderStop = () => ({
  type: WELD_PARAMETERS_LOADER_STOP,
});

export const updateRenamePasses = (payload) => ({
  type: UPDATE_RENAME_PASSES,
  payload: payload,
});

export const putRenameLoaderStart = () => ({
  type: PUT_RENAME_LOADER_START,
});

export const putRenameLoaderStop = () => ({
  type: PUT_RENAME_LOADER_STOP,
});
